import React, { useState } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import FirstFastCheckDateEditModal from './FirstFastCheckDateEditModal';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
const ProjectBody = _ref => {
  let {
    project,
    fetchAllProjetcs
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showDateEditModal, setShowDateEditModal] = useState(false);
  const location = useLocation();
  const renderBsfzApplicationNumber = () => {
    if (project.bsfz_certificates?.length > 0) {
      return project.bsfz_certificates.sort(function (a, b) {
        return a.id - b.id;
      }).at(-1).application_number;
    } else {
      return '';
    }
  };
  const timesheetValue = () => {
    return project.name_lists?.length > 0 ? 'Filled in' : 'Need to be updated';
  };
  const staffCostValue = () => {
    return project.staff_costs?.length > 0 ? 'Filled in' : 'Need to be updated';
  };
  const actions = ['elster_form_created', 'elster_form_submitted', 'additional_claims', 'approval_of_financial_claim', 'invoicing'];
  const projectActions = actions.map((a, i) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: 'project_actions' + a
    }, /*#__PURE__*/React.createElement("td", null, t(a)), /*#__PURE__*/React.createElement("td", null, "01.03.2024"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: () => {},
      className: "ms-auto me-3"
    }, t('upload_document'))), /*#__PURE__*/React.createElement("td", null, i === 0 && /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: () => {},
      className: "ms-auto me-3"
    }, t('create_elster'))));
  });
  const projectActionsTable = /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    style: {
      width: '50%',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('action')), /*#__PURE__*/React.createElement("th", null, t('date')), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null)), projectActions));
  const renderProjectHasDocumentation = () => {
    if (project.additional_documentations.length > 0) {
      return /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-success"
      }, "done");
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-danger"
      }, "close");
    }
  };
  const renderAllInvoicesCollectedStatus = () => {
    if (project.all_invoices_collected_and_updated) {
      return /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-success"
      }, "done");
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-danger"
      }, "close");
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showDateEditModal && /*#__PURE__*/React.createElement(FirstFastCheckDateEditModal, {
    show: showDateEditModal,
    onHide: () => setShowDateEditModal(false),
    project: project,
    fetchAllProjetcs: fetchAllProjetcs
  }), /*#__PURE__*/React.createElement(Row, {
    key: project.id,
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Link, {
    to: `${location.pathname}?main_tab=project_details&sub_tab1=employee&p_id=${project.id}`
  }, project.project_name)), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, createTimezonedDate(project.first_fast_check.lifetime_of_the_customer_project_from, true).toCustomLocaleDateString()), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, createTimezonedDate(project.first_fast_check.lifetime_of_the_customer_project_to, true).toCustomLocaleDateString()), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, renderBsfzApplicationNumber()), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, timesheetValue()), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, staffCostValue()), /*#__PURE__*/React.createElement(Col, {
    md: 2,
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, renderAllInvoicesCollectedStatus())), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, "To be added"), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => setShowDateEditModal(true),
    className: "ms-auto me-3"
  }, t('change_end_date')))));
};
export default ProjectBody;